import React from 'react';
import { useSelector } from 'react-redux';
import { Breadcrumb, Tooltip } from 'antd';
import { useAtom } from 'jotai';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { isAdminRoleSelector } from '@src/store/common/selectors';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { DataSourceMapping } from '@src/pages/SavedDashboards/utils';
import AdminOnly from '@src/components/common/AdminOnly';
import { isCreateRuleFormOpenAtom, editingRuleAtom } from '../atoms';
import { HeaderProps } from '../types';
import {
  Divider,
  HeaderWrapper,
  LeftSideHeader,
  RightSideHeader,
  StyledButton,
  Title,
} from '../styled';

const Header = ({ closeDrawer }: HeaderProps) => {
  const isAdminUser = useSelector(isAdminRoleSelector);
  const [isFormOpen, setIsFormOpen] = useAtom(isCreateRuleFormOpenAtom);
  const [editingRule, setEditingRule] = useAtom(editingRuleAtom);

  const isEditing = editingRule !== null;
  const showingForm = isFormOpen || isEditing;

  const handleBackToList = () => {
    setIsFormOpen(false);
    setEditingRule(null);
  };

  const breadcrumbItems = [
    {
      key: 'Mute Rules',
      title: (
        <>
          Mute Rules
          <AdminOnly style={{ position: 'relative', top: '-3px', marginLeft: '10px' }} />
        </>
      ),
      clickable: showingForm,
      show: true,
      onClick: showingForm ? handleBackToList : undefined,
    },
    {
      key: 'New Rule',
      title: 'New Rule',
      clickable: false,
      show: isFormOpen && !isEditing,
    },
    {
      key: 'Edit Rule',
      title: 'Edit Rule',
      clickable: false,
      show: isEditing,
    },
  ];

  return (
    <HeaderWrapper>
      <LeftSideHeader>
        <Title>{DataSourceMapping[(CURRENT_PRODUCT_MODE || '').toLowerCase()]}</Title>
        <Divider />
        <Breadcrumb separator=">">
          {breadcrumbItems.map((item) =>
            item.show ? (
              <Breadcrumb.Item onClick={item.onClick} key={item.key}>
                <Title clickable={item.clickable}>{item.title}</Title>
              </Breadcrumb.Item>
            ) : null,
          )}
        </Breadcrumb>
      </LeftSideHeader>

      <RightSideHeader>
        {!showingForm ? (
          <Tooltip title={isAdminUser ? '' : 'Only admins can create, edit, or delete rules'}>
            <StyledButton
              type="primary"
              ghost
              disabled={!isAdminUser}
              onClick={() => isAdminUser && setIsFormOpen(true)}
              icon={<PlusOutlined />}
            >
              New Rule
            </StyledButton>
          </Tooltip>
        ) : null}
        <CloseOutlined style={{ paddingTop: '8px' }} onClick={closeDrawer} />
      </RightSideHeader>
    </HeaderWrapper>
  );
};

export default Header;
